"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Blower;

var _Blower = require("@adobe/react-spectrum-workflow/dist/Blower");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Blower(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Blower.A4uBlower, null));
}